import React from "react";

/**
 * Form field wrapper used across all dashboard panels.
 * Renders a small caps eyebrow label and the children below.
 *
 * Kept here (not in /components shared) because the styling assumptions are
 * dashboard-specific (zinc palette, dark mode, tracking).
 */
export default function Field({ label, children }) {
  return (
    <div>
      <label className="text-xs font-semibold tracking-[0.15em] uppercase text-zinc-500 dark:text-zinc-400">{label}</label>
      <div className="mt-2">{children}</div>
    </div>
  );
}
